const smooth=(start,end,value)=>{
  const t=Math.max(0,Math.min(1,(value-start)/(end-start)));
  return t*t*(3-2*t);
};

// Text and objects share the same envelope. Outgoing content clears before
// incoming content appears; text never enlarges past its designed size.
export function sampleChapter({top,nextTop,scroll,height,first=false}){
  const enter=first?1:smooth(top-height*.15,top,scroll);
  const leave=nextTop==null?0:smooth(nextTop-height*.60,nextTop-height*.25,scroll);
  return {enter,opacity:enter*(1-leave),depth:-80*(1-enter)};
}

// A shorter scroll span keeps the symbolic sequence and its single turn intact.
export const SYMBOL_SCROLL_VH=320;
const SYMBOL_TIMELINE_UNITS=540;
export function sampleSymbolScroll(progress){
  const travel=Math.max(0,Math.min(1,progress))*SYMBOL_TIMELINE_UNITS;
  const revealAt=330*.86;
  const viewingTravel=Math.max(0,Math.min(210,travel-revealAt));
  return {
    progress:(travel-viewingTravel)/330,
    turn:Math.PI*2*smooth(revealAt+20,revealAt+170,travel)
  };
}

// Fit the final emblem above the complete caption, including its eyebrow.
// Reserve perspective room so the gap survives the emblem's rotation.
export function fitSymbolReveal({width,height,captionTop,emblemWidth=3.2,emblemHeight=3.1,centerY=0}){
  const viewHeight=2*Math.tan(Math.PI/10)*8;
  const top=Math.max(76,height*.10);
  const gap=Math.max(32,Math.min(64,height*.06));
  const bottom=Math.max(top+40,captionTop-gap);
  const scale=.86*Math.min((bottom-top)/height*viewHeight/emblemHeight,viewHeight*width/height*.84/emblemWidth);
  return {scale,y:(.5-(top+bottom)/2/height)*viewHeight-centerY*scale};
}